import { Principal } from "src/types/AddMerchant/merchantInfo";

export default function findBillingContact(principals: Principal[]): Principal | null | undefined {
    return principals?.find((principal) => {
        return principal.isBillingContact;
    });
}
